/**
 * NoteCallout — generic info (💡) / warning (⚠️) callout.
 * Shared by chapters 2726..2729 (CX-2725 §3). `tone` drives the accent color.
 */

import type { NoteCallout as NoteCalloutData } from "../chapter.types";
import "./NoteCallout.css";

interface NoteCalloutProps {
  note: NoteCalloutData;
}

/** Price-tag glyph (Figma node 1658-11622). Inlined as SVG because the 🏷️
 *  emoji renders inconsistently across platform emoji fonts. */
const TagIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    className="note-callout__tag"
  >
    <path
      d="M10.4 2.5H3.75a1.25 1.25 0 0 0-1.25 1.25v6.65a1.25 1.25 0 0 0 .366.884l6.5 6.5a1.25 1.25 0 0 0 1.768 0l6.65-6.65a1.25 1.25 0 0 0 0-1.768l-6.5-6.5a1.25 1.25 0 0 0-.884-.366Z"
      fill="#F4B183"
      stroke="#E08A50"
      strokeWidth="1"
      strokeLinejoin="round"
    />
    <circle
      cx="6.5"
      cy="6.5"
      r="1.35"
      fill="#fff"
      stroke="#E08A50"
      strokeWidth="0.9"
    />
  </svg>
);

export const NoteCallout = ({ note }: NoteCalloutProps) => (
  <aside className={`note-callout note-callout--${note.tone ?? "info"}`}>
    <span className="note-callout__icon" aria-hidden="true">
      {note.icon === "tag" ? <TagIcon /> : note.icon}
    </span>
    <p className="note-callout__text">{note.text}</p>
  </aside>
);
